import { render, staticRenderFns } from "./BaseInsights.vue?vue&type=template&id=7651d3e2&scoped=true&"
import script from "./BaseInsights.vue?vue&type=script&lang=js&"
export * from "./BaseInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651d3e2",
  null
  
)

export default component.exports